export interface AuthConnection {
  id?: number;
  uId: string;
  organizationUId?: string;
  ownedDomains: string;
  authConnectionType: AuthConnectionTypesEnumDto;
  name: string;
  description: string;
  connectionId: string;
  connectionData?: string;
}

export enum AuthConnectionTypesEnumDto {
  auth0 = 1,
  topoOne = 2
}
